var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { height: _vm.screenH + "px" }, attrs: { id: "customPrint" } },
    [
      _vm.isShowInviteTip
        ? _c("div", { staticClass: "layer-wrapper" })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "y-p-r y-mt-8" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "data-tabs",
              style: { "min-height": _vm.screenH - 20 + "px" },
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "ADD_ORDER", label: "新建订单" } },
                [
                  _vm.activeName == "ADD_ORDER"
                    ? _c("addPrintOrder", {
                        ref: "addOrders",
                        attrs: {
                          rowInfo: _vm.rowInfo,
                          bindUserInfo: _vm.bindUserInfo,
                          bindSellerInfo: _vm.bindSellerInfo,
                        },
                        on: {
                          goApplyOrder: _vm.goApplyOrderFn,
                          geToRecharge: _vm.geToRecharge,
                          openSaveAccount: _vm.openSaveAccount,
                          hasActiveAuth: _vm.hasActiveAuth,
                          goToRealName: _vm.goToRealName,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "批量导入", name: "EXPORT_ORDER" } },
                [
                  _vm.activeName == "EXPORT_ORDER"
                    ? _c("exportOrder", {
                        ref: "EXPORT_ORDER",
                        attrs: {
                          curComponent: "EXPORT_ORDER",
                          bindSellerInfo: _vm.bindSellerInfo,
                        },
                        on: { goApplyOrder: _vm.goApplyOrderFn },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "待打印", name: "APPLY_ORDER" } },
                [
                  _vm.activeName == "APPLY_ORDER"
                    ? _c("printintList", {
                        ref: "APPLY_ORDER",
                        attrs: {
                          curComponent: "APPLY_ORDER",
                          savePrintData: _vm.savePrintData,
                        },
                        on: {
                          copyOrder: _vm.copyOrderFn,
                          getPrintData: _vm.goApplyOrderFn,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "已打印", name: "PRINTED_ORDER" } },
                [
                  _vm.activeName == "PRINTED_ORDER"
                    ? _c("printintList", {
                        ref: "PRINTED_ORDER",
                        attrs: { curComponent: "PRINTED_ORDER" },
                        on: { copyOrder: _vm.copyOrderFn },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "全部订单", name: "ALL_ORDER" } },
                [
                  _vm.activeName == "ALL_ORDER"
                    ? _c("printintList", {
                        ref: "ALL_ORDER",
                        attrs: { curComponent: "ALL_ORDER" },
                        on: { copyOrder: _vm.copyOrderFn },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "y-p-a right-btn y-f y-f-a y-f-je" },
            [
              _vm.bindSellerInfo && _vm.bindSellerInfo.name
                ? _c(
                    "span",
                    {
                      staticClass: "merchant-box y-c-p y-mr-20",
                      on: { click: _vm.viewBindSellerFn },
                    },
                    [
                      _vm._v(" 已绑定："),
                      _c("span", { staticClass: "merchant-code systemColor" }, [
                        _vm._v(_vm._s(_vm.bindSellerInfo.name)),
                      ]),
                      _vm._v(" 为专属业务员 "),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "merchant-box y-c-p y-mr-20 systemColor",
                      on: { click: _vm.bindSellerFn },
                    },
                    [_vm._v(" 绑定专属业务员 ")]
                  ),
              _c(
                "el-button",
                {
                  staticClass: "border-btn header-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.freightRateInquiryFn },
                },
                [_vm._v("运费报价")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.freightRateInquiryFlag
        ? _c("freightRateInquiry", {
            attrs: { visible: _vm.freightRateInquiryFlag },
            on: {
              "update:visible": function ($event) {
                _vm.freightRateInquiryFlag = $event
              },
            },
          })
        : _vm._e(),
      _vm.rechareCardHelpFlag
        ? _c("rechareCardHelp", {
            attrs: { visible: _vm.rechareCardHelpFlag },
            on: {
              "update:visible": function ($event) {
                _vm.rechareCardHelpFlag = $event
              },
            },
          })
        : _vm._e(),
      _vm.isShowPrivacyDialog
        ? _c("privacy", {
            attrs: { isShow: _vm.isShowPrivacyDialog, isCheckedPrivacy: false },
            on: { close: _vm.closePrivacyDialog },
          })
        : _vm._e(),
      _vm.showInviteSettingDialog
        ? _c("inviteSetting", {
            attrs: { isShow: _vm.showInviteSettingDialog },
            on: { closeDialog: _vm.closeInviteSettingDialog },
          })
        : _vm._e(),
      _vm.collecAccountDialog
        ? _c("save-account", {
            ref: "setCollecAccount",
            attrs: {
              value: _vm.collecAccountDialog,
              data: _vm.collecAccountData,
              from: "returnPickupPrint",
            },
            on: { close: _vm.closeCollecAccount },
          })
        : _vm._e(),
      _vm.realNameDialog
        ? _c("real-name", {
            ref: "realName",
            attrs: {
              value: _vm.realNameDialog,
              data: _vm.realNameInfo,
              id: _vm.accountInfo.id || "",
            },
            on: { close: _vm.closeRealName },
          })
        : _vm._e(),
      _vm.preAlipayAndRealNameFlag
        ? _c("preAlipayAndRealNameDialog", {
            ref: "preAlipayAndRealName",
            attrs: {
              realNameId: _vm.realNameId,
              isShow: _vm.preAlipayAndRealNameFlag,
            },
            on: {
              openRealNameDialog: _vm.openRealNameDialog,
              goOpenAliDialog: _vm.goOpenAliDialog,
              closeDialog: _vm.closePreAlipayAndRealName,
              openSaveAccount: _vm.openSaveAccount,
            },
          })
        : _vm._e(),
      _c("AuthRealName", {
        attrs: {
          showAuthRealNameDialog: _vm.showAuthRealNameDialog,
          showType: _vm.showType,
          certInfo: _vm.certInfo,
        },
        on: {
          "update:showAuthRealNameDialog": function ($event) {
            _vm.showAuthRealNameDialog = $event
          },
          "update:show-auth-real-name-dialog": function ($event) {
            _vm.showAuthRealNameDialog = $event
          },
          update: _vm.closeAuthRealNameAndUpdate,
        },
      }),
      _vm.showActivityDialog
        ? _c("activitySetting", {
            attrs: {
              isShow: _vm.showActivityDialog,
              bindUser: _vm.bindUserInfo,
            },
            on: { closeDialog: _vm.closeActivityDialog },
          })
        : _vm._e(),
      _vm.showBindSellerDialog
        ? _c("bindSellerInfo", {
            attrs: {
              isShow: _vm.showBindSellerDialog,
              bindUser: _vm.bindSellerInfo,
              bindType: _vm.bindType,
              operateType: "SELLER",
            },
            on: { closeDialog: _vm.closeBindSellerDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }